import { api } from './api';
import type { Chain } from './transfers';

export interface ResolvedRecipient {
  tgUserId: string;
  chain: Chain;
  address: string;
  displayName: string | null;
}

/** Telegram IDs are positive decimal integers. Keep them as strings to avoid
 * losing precision when they cross the JavaScript safe-integer boundary. */
export function parseTelegramId(value: string): string | null {
  const trimmed = value.trim();
  return /^[1-9]\d{0,18}$/.test(trimmed) ? trimmed : null;
}

/** Telegram @username (5–32 chars). Strips leading @; returns lowercase. */
export function parseTelegramUsername(value: string): string | null {
  const trimmed = value.trim().replace(/^@+/, '');
  if (!/^[A-Za-z][A-Za-z0-9_]{4,31}$/.test(trimmed)) return null;
  return trimmed.toLowerCase();
}

export function fetchResolvedRecipient(initData: string, tgUserId: string, chain: Chain) {
  const query = new URLSearchParams({ tgUserId, chain });
  return api<ResolvedRecipient>(initData, `/v1/users/resolve-recipient?${query}`);
}
